import React, { useEffect, useState } from 'react';

import Head from 'next/head';
import getMetaTagData from '../src/common/services/getMetaTagData';
import MainTop from '../src/component/pc/maintop/MainTop';
import MainBottom from '../src/component/pc/MainBottom/MainBottom';

function Ci({ metaTagData, jWTCheck }) {
  const sectionStyle = {
    backgroundImage: 'url(styles/2022/pc/img/CI_visual.png)'
  };

  // gtag
  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      window.dataLayer = window.dataLayer || [];
      function gtag() { dataLayer.push(arguments); }
      gtag('js', new Date());
      gtag('config', 'UA-104756746-1');
      gtag('config', 'G-L9E7Y63ZNE');
    }
  }, []);

  return (
    <>
      <script async src='https://www.googletagmanager.com/gtag/js?id=UA-104756746-1' />
      <Head>
        <link key='css_pc_url' rel='stylesheet' href={process.env.NEXT_PUBLIC_GLOBAL_CSS_PC_URL} />
        <meta key='viewport' name='viewport' content='width=device-width, initial-scale=1' />
        <meta name='description' content="SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!" />
        <meta name='keywords' content={metaTagData.keywords} />
        <meta name='twitter:card' content='summary' />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property='og:type' content='website' />
        <meta property='og:locale' content='ko_KR' />
        <meta property='og:site_name' content='SBS' />
        <meta property='og:title' content={'' || ''} />
        <meta property='og:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta property='og:image' content={metaTagData.shareImageUrl || ''} />
        <meta property='og:url' content={metaTagData.currentUrl || ''} />
        <meta name='nate:site_name' content='SBS' />
        <meta name='nate:title' content={'' || ''} />
        <meta name='nate:description' content={'SBS의 대표 프로그램과 서비스 등 30년 히스토리와 최근 소식을 만나보세요!' || ''} />
        <meta name='nate:image' content={metaTagData.shareImageUrl || ''} />
        <meta name='nate:url' content={metaTagData.currentUrl || ''} />
        <title>CI : SBS 소개 : SBS</title>
      </Head>

      <ul id='skip_nav'>
        <li><a href='#container'>본문컨텐츠</a></li>
        <li><a href='#header'>헤더 메뉴</a></li>
      </ul>

      <div id='wrap' className='sbsabout_wrap'>
        {/* <!-- 헤더 --> */}
        <MainTop />
        {/* <!-- 컨텐츠영역 --> */}
        <div id='container' className='contents'>
          <h2 className='hide'>SBS</h2>
          {/* <!-- 비쥬얼영역 --> */}
          {/* "background-image:url('../img/CI_visual.png');" */}
          <div className='sbsabout_visual_top_ci' style={sectionStyle}>
            <div className='sbsabout_inner'>
              <h3 className='sbsabout_visual_title'>CI</h3>
            </div>
          </div>
          {/* <!-- 컨텐츠 --> */}
          <div className='ci_contents_w'>
            {/* <!-- 심볼마크 --> */}
            <div className='ci_contents01'>
              <div className='sbsabout_inner'>
                <h4 className='ci_title'>
                  심볼마크
                  <span className='ci_title_eng'>Corporate<br />Symbol Mark</span>
                </h4>
                <div className='ci_infotext_w'>
                  <div className='ci_infotext_inner'>
                    <p className="ci_infotext">
                      심볼마크는 SBS의 이미지를 대표하는 요소로서 일관된 이미지를 전달하기 위해 사용에 특별한 주의를 요한다.
                    </p>
                    <span class="ci_infotext">
                      - 심볼 중앙의 원(circle) 영역은 투명하지 않고 채워져 있는 형태로 사용한다.<br />
                      - 심볼마크 최소규정 : 7mm
                    </span>
                    <div className='ci_image_box'>
                      <span className='svg_icon_symbol'>
                        <svg width='205' height='205.339' viewBox='0 0 205 205.339' alt='지혜의 눈'>
                          <defs>
                            <clipPath id='symbol-path'>
                              <rect id='symbol_83' data-name='symbol 83' width='205' height='205.339' fill='none' />
                            </clipPath>
                          </defs>
                          <g id='Symbol_Mark' data-name='Symbol Mark' clipPath='url(#symbol-path)'>
                            <path id='symbol_path_378' data-name='symbol_path 378' d='M203.836,117.678c2.5-24.563,1.865-30.212-10.947-47.568-3.236-4.382-5.728-8.316-1.332-7.156,4.062,1.069,1.057-8.085,4.837-5.8-5.962-27.338-38.76-43.573-63.754-52.646Q123.756,2.577,114.88.631C111.594.642,106.987,0,103.7,0,82.668,2.645,62.909,2.752,45.187,15.153c-5.255,3.916-10.466,11.013-16.378,16.233-3.279,3.27-4.585,5.871-7.876,9.134C7.821,56.823,0,81.273,0,95.258,0,136.14,13.11,166.909,51.2,187.8c4.086,2.245,31.117,15.621,46.376,17.174,20.755,2.115,44.258-5.634,47-7.734,4.029-3.082,9.926-3.485,14.773-8.165s11.888-8.807,15.308-15.553c4.512-8.9,31.846-38.272,29.183-55.847' fill='#0075c4' />
                            <path id='symbol_path_379' data-name='symbol_path 379' d='M181.094,122.429c1.5-14.736,1.123-18.126-6.559-28.545-1.949-2.626-3.439-4.995-.8-4.293,2.427.637,3.193-2.52,2.9-3.48-3.582-16.4-23.253-26.146-38.259-31.584q-5.324-1.164-10.652-2.33c-1.974.006-4.735-.387-6.712-.378-12.615,1.59-24.469,1.649-35.106,9.089-3.152,2.35-6.281,6.612-9.828,9.748-1.962,1.955-2.746,3.512-4.719,5.478-7.87,9.776-11.4,20.721-12.56,32.844-.353,24.219,7.871,42.988,30.716,55.526,2.453,1.346,19.077,9.211,27.828,10.308,10.357,1.287,24.255-2.683,28.195-4.643,3.159-2.356,6.509-2.16,8.866-4.911,1.97-1.955,6.57-4.966,7.754-7.31,5.5-8.991,20.544-24.973,18.937-35.52' transform='translate(-14.553 -12.829)' fill='#f99900' />
                            <path id='symbol_path_380' data-name='symbol_path 380' d='M82.339,101.763a44.806,44.806,0,1,1,20.15,60.106,44.779,44.779,0,0,1-20.15-60.106' transform='translate(-19.22 -19.036)' fill='#fff' />
                          </g>
                        </svg>
                        <i className='hide'>SBS 심볼마크 이미지</i>
                      </span>
                    </div>
                    <div className="ci_symbolcolor_w">
                      <div className="cisc_inner">
                        <strong className="cisc_name bg_orange">Orange</strong>
                      </div>
                      <div className="cisc_inner">
                        <strong className="cisc_name bg_skyblue">Sky Blue</strong>
                      </div>
                      <div className="cisc_inner">
                        <strong className="cisc_name bg_white">White</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- 로고타입 --> */}
            <div className='ci_contents02'>
              <div className='sbsabout_inner'>
                <h4 className='ci_title'>
                  로고타입
                  <span className='ci_title_eng'>Logotype</span>
                </h4>
                <div className='ci_infotext_w'>
                  <div className='ci_infotext_inner'>
                    <p className='ci_infotext'>
                      로고타입은 심볼마크와 더불어 SBS의 시각적 이미지를 전달하는 가장 기본적인 요소이다.<br />
                      각각의 글자꼴 형태에 따라 비례조정한 것이므로 모양과 굵기, 비례등을 임의로 변경하는 것을 금한다.
                    </p>
                    <div className='ci_image_box'>
                      <span className='svg_icon_logo'>
                        <svg width='236.24' height='105.551' viewBox='0 0 236.24 105.551' alt='SBS 로고'>
                          <defs>
                            <clipPath id='sbslogo-path'>
                              <rect id='sbslogo_88' data-name='sbslogo 88' width='236.24' height='105.551' fill='none' />
                            </clipPath>
                          </defs>
                          <g id='SBS_logo' clipPath='url(#sbslogo-path)'>
                            <path id='sbslogo_path_381' data-name='sbslogo_path 381' d='M57.385,49.826,32.361,26.858a8.255,8.255,0,0,1-2.826-6.207,8.939,8.939,0,0,1,9.17-8.678H66.384V0H24.049C10.918,0,0,8.843,0,22.693A21.909,21.909,0,0,0,6.33,38.037L35.814,65.849s4.969,3.594,3.242,9.512-9.249,5.921-12.073,5.921H.006v24.268h40.94c16.557,0,29.981-12.664,29.981-28.288v-.222c.459-11.669-5.817-20.054-13.542-27.216' transform='translate(0 0)' fill='#003f79' />
                            <path id='sbslogo_path_382' data-name='sbslogo_path 382' d='M227.823,49.826,202.812,26.858a8.249,8.249,0,0,1-2.841-6.207,8.947,8.947,0,0,1,9.179-8.678H236.83V0H194.5c-13.135,0-24.053,8.843-24.053,22.693a21.915,21.915,0,0,0,6.331,15.345l29.48,27.812s4.975,3.594,3.247,9.512-9.254,5.921-12.079,5.921H170.45v24.268h40.942c16.554,0,29.978-12.664,29.978-28.288v-.222c.459-11.669-5.819-20.054-13.547-27.216' transform='translate(-5.153 0)' fill='#003f79' />
                            <path id='sbslogo_path_383' data-name='sbslogo_path 383' d='M162.049,74.908c0-12.669-7.076-24.89-21.256-29.733,10.731-3.29,16.3-11.174,16.3-22.259a21.642,21.642,0,0,0-9.056-17.722C140.084-.282,128.171.143,128.171.143l-.007-.02H81.438l.017,105.417h49.71c4.193-.2,13.051-1.347,20.222-7.2a31.3,31.3,0,0,0,10.662-23.432M106.717,12.167h11.22c1.7,0,13.427.008,14.4,11.417.7,8.179-4.873,13.289-13.863,13.289H106.717ZM120.2,81.3h-13.48V53.212h12.942c1.7,0,14.782.016,15.755,12.984.693,9.292-6.227,15.1-15.218,15.1' transform='translate(-2.462 -0.004)' fill='#003f79' />
                          </g>
                        </svg>
                        <i className='ir'>SBS 로고 이미지</i>
                      </span>
                    </div>
                    <div className='logo_down_w'>
                      <a href='/download/SBS CI_AI.zip' className='btn_logo_down' download>
                        <span className='bld_text'>AI 파일 다운로드<span className='svg_icon_down' /></span>
                      </a>
                      <a href='/download/SBS CI_PNG.zip' className='btn_logo_down' download>
                        <span className='bld_text'>PNG 파일 다운로드<span className='svg_icon_down' /></span>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* <!-- 전용색상 --> */}
            <div className='ci_contents03'>
              <div className='sbsabout_inner'>
                <h4 className='ci_title'>
                  전용색상
                  <span className='ci_title_eng'>Color System</span>
                </h4>
                <div className='ci_infotext_w'>
                  <div className='ci_infotext_inner'>
                    <p className='ci_infotext'>
                      전용색상은 심볼마크 로고타입과 더불어 SBS의 아이덴티티를 형성하는 3대 요소중의 하나이다.<br />
                      또한 심볼마크와 로고타입 및 각종 시각매체에 적용하여 SBS의 이미지를 전달하는 기능을 한다.
                    </p>
                    <p className='ci_infotext'>
                      전용색상의 표현에서 RGB와 HEX는 방송, 온라인. CMYK는 별색처리가 불가능한 신문, 잡지 등 인쇄물의 규정.<br />
                      Pantone Color는 별색인쇄나 페인팅, 컬러시트 등 프로세스가 불가능한 사용의 규정이다.
                    </p>
                  </div>
                  <div className='ci_primarycolor_w'>
                    <strong className='ci_cont_title'>방송용/인쇄용</strong>
                    <span className='primarycolor_title'>Primary Color</span>
                    <div className='primarycolor_box_w'>
                      <div className='primarycolor_box'>
                        <strong className='primarycolor_name bg_skyblue'>SBS Sky Blue</strong>
                        <ul className='primarycolor_list'>
                          <li className='pcl_cont'>
                            <strong>PANTONE</strong>
                            <span>Process Blue C</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>CMYK</strong>
                            <span>C90 M30 Y0 K0</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>RGB</strong>
                            <span>R0 G133 B205</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>HEX</strong>
                            <span>0085CD</span>
                          </li>
                        </ul>
                      </div>
                      <div className='primarycolor_box'>
                        <strong className='primarycolor_name bg_orange'>SBS Orange</strong>
                        <ul className='primarycolor_list'>
                          <li className='pcl_cont'>
                            <strong>PANTONE</strong>
                            <span>137C</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>CMYK</strong>
                            <span>C0 M40 Y95 K0 </span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>RGB</strong>
                            <span>R246 G171 B0</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>HEX</strong>
                            <span>F6AB00</span>
                          </li>
                        </ul>
                      </div>
                      <div className='primarycolor_box'>
                        <strong className='primarycolor_name bg_darkblue'>SBS Dark Blue</strong>
                        <ul className='primarycolor_list'>
                          <li className='pcl_cont'>
                            <strong>PANTONE</strong>
                            <span>301C</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>CMYK</strong>
                            <span>C100 M50 Y0 K30</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>RGB</strong>
                            <span>R0 G81 B146</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>HEX</strong>
                            <span>005192</span>
                          </li>
                        </ul>
                      </div>
                      <div className='primarycolor_box'>
                        <strong className='primarycolor_name bg_white'>SBS White</strong>
                        <ul className='primarycolor_list'>
                          <li className='pcl_cont'>
                            <strong>CMYK</strong>
                            <span>C0 M0 Y0 K0</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>RGB</strong>
                            <span>R255 G255 B255</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>HEX</strong>
                            <span>FFFFFF</span>
                          </li>
                        </ul>
                      </div>
                      <div className='primarycolor_box'>
                        <strong className='primarycolor_name bg_lightgray'>SBS Light Gray</strong>
                        <ul className='primarycolor_list'>
                          <li className='pcl_cont'>
                            <strong>PANTONE</strong>
                            <span>427C</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>CMYK</strong>
                            <span>C21 M15 Y15 K0</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>RGB</strong>
                            <span>R209 G211 B211</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>HEX</strong>
                            <span>D1D3D3</span>
                          </li>
                        </ul>
                      </div>
                      <div className='primarycolor_box'>
                        <strong className='primarycolor_name bg_darkgray'>SBS Dark Gray</strong>
                        <ul className='primarycolor_list'>
                          <li className='pcl_cont'>
                            <strong>PANTONE</strong>
                            <span>429C</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>CMYK</strong>
                            <span>C41 M31 Y28 K0</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>RGB</strong>
                            <span>R164 G169 B173</span>
                          </li>
                          <li className='pcl_cont'>
                            <strong>HEX</strong>
                            <span>A4A9AD</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* <!-- 방송용 응용--> */}
                  <div className='ci_boundarycolor_w'>
                    <strong className='ci_cont_title'>방송용 응용</strong>
                    <div className='boundarycolor_box'>
                      <span className='primarycolor_title'>Blue boundary</span>
                      <div className='boundarycolor_cont'>
                        <div className='bc_round_small bg_deepblue' />
                        <div className='bc_round_big bg_darkblue'><span className='bc_round_txt'>SBS<br />Dark<br />Blue</span></div>
                        <div className='bc_round_big bg_skyblue'><span className='bc_round_txt'>SBS<br />Sky<br />Blue</span></div>
                        <div className='bc_round_small bg_lightblue' />
                      </div>
                    </div>
                    <div className='boundarycolor_box'>
                      <span className='primarycolor_title'>Orange boundary</span>
                      <div className='boundarycolor_cont'>
                        <div className='bc_round_big bg_white'><span className='bc_round_txt'>SBS<br />White</span></div>
                        <div className='bc_round_small bg_yellow' />
                        <div className='bc_round_big bg_orange'><span className='bc_round_txt'>SBS<br />Orange</span></div>
                        <div className='bc_round_small bg_darkorange' />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        {/* <!-- 풋터 --> */}
        <MainBottom />
      </div>

    </>
  );
}

export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;

  const jWTCheck = !!LOGIN_JWT;
  const metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory);

  return { props: { metaTagData, jWTCheck } };
}

export default Ci;
